<div class="width-100 historico-mapas-infestacao">
  <div class="container-header">
    <div ng-if="$root.permissions.ocorrencia.canManage || $root.permissions.mapas.canManage"
         class="pull-right text-muted menu-dropdown" uib-dropdown dropdown-append-to-body="true">
      <button type="button" class="btn-link" uib-dropdown-toggle>
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <ul class="dropdown-menu-sidebar" uib-dropdown-menu>
        <li ng-if="$root.permissions.mapas.canManage">
          <a ng-click="mapas.createNewMap()">
            <i class="fa fa-plus"></i> Criar novo mapa
          </a>
        </li>
        <li ng-if="$root.permissions.ocorrencia.canManage">
          <a ng-click="mapas.generateInfestationMaps()">
            <i class="fa fa-refresh" aria-hidden="true"></i> Gerar Novos Mapas de Infestação
          </a>
        </li>
      </ul>
    </div>
    <div class="clearfix"></div>

    <div class="title text-center">
      <h2 ng-show="mapas.filters.gleba">
        <strong>{{::(mapas.filters.gleba.descricao | characters:20)}}</strong>
      </h2>
      <h2 ng-hide="mapas.filters.gleba">
        <strong>MAPAS DE DADOS</strong>
      </h2>
    </div>

    <div ng-show="mapas.initialized">
      <!-- Filtros -->
      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
          {{mapas.filters.tipo.descricao || 'Tipo' | characters: 12}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu>
          <li ng-show="mapas.filters.tipo">
            <a ng-click="mapas.setFilterAttribute('tipo', null, $event)">Todos</a>
          </li>
          <li class="divider" ng-show="mapas.filters.tipo"></li>
          <li ng-repeat="tipo in mapas.mapTypes | orderBy: 'descricao'">
            <a ng-click="mapas.setFilterAttribute('tipo', tipo, $event)">{{::tipo.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{mapas.filters.safra.descricao || 'Safra' | characters:12}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="mapas.filters.safra">
            <a ng-click="mapas.setFilterAttribute('safra', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="mapas.filters.safra"></li>
          <li role="menuitem" ng-repeat="safra in $root.safras | orderBy: '-descricao'">
            <a ng-click="mapas.setFilterAttribute('safra', safra, $event)" href="#">{{::safra.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" ng-show="mapas.filters.tipo.id === 'pragas'">
        <button type="button" class="btn" uib-dropdown-toggle>
            {{(mapas.filters.subtipo.descricao || 'Praga')}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="mapas.filters.subtipo">
            <a ng-click="mapas.setFilterAttribute('subtipo', null, $event)" href="#">Todos</a>
          </li>
          <li class="divider" ng-show="mapas.filters.subtipos"></li>
          <li role="menuitem" ng-repeat="subtipo in mapas.subtipos | orderBy: 'descricao' track by subtipo.id">
            <a ng-click="mapas.setFilterAttribute('subtipo', subtipo, $event)" href="#">{{::subtipo.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" ng-hide="currentGleba && mapas.filters.gleba">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{(mapas.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="mapas.filters.gleba">
            <a ng-click="mapas.setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="mapas.filters.gleba"></li>
          <li role="menuitem" ng-repeat="gleba in mapas.glebas | orderBy: 'descricao' track by gleba.id">
            <a ng-click="mapas.setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <button type="button" class="btn" ng-click="mapas.openPeriodsFilter($event)">
          {{mapas.periodo.periodo || 'Período'}} <span class="caret"></span>
        </button>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <button type="button" class="btn">
          <i
            class="fa pointer"
            ng-class="{'fa-star-o': !mapas.filters.favorites, 'fa-star': mapas.filters.favorites}">
          </i>
        </button>

        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="mapas.filters.favorites !== undefined">
            <a ng-click="mapas.setFilterAttribute('favorites', undefined, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="mapas.filters.favorites !== undefined"></li>
          <li role="menuitem">
            <a ng-click="mapas.setFilterAttribute('favorites', true, $event)" href="#">Somente favoritados</a>
          </li>
          <li role="menuitem">
            <a ng-click="mapas.setFilterAttribute('favorites', false, $event)" href="#">Somente não favoritados</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Fim Filtros -->
    <br><br>
  </div>

  <div ng-if="mapas.bulkPrint.length > 0" class="text-center">
    <ng-include src="'bulk-print-maps.html'"></ng-include>
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-white"
        ng-print
        print-element-id="bulk-print-maps"
        ng-disabled="mapas.loadingMapData">
        <i class="fa fa-print"></i>
        Imprimir selecionados
      </button>
      <button
        type="button"
        class="btn btn-white"
        ng-click="mapas.clearBulkPrint()">
        <i class="fa fa-close"></i>
        Limpar
      </button>
    </div>
  </div>
  <p class="text-center margin text-cinza" ng-show="mapas.loadingMapData">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
  </p>
  <div ng-if="mapas.hasLegend()" class="map-legenda">
    <h3>
      Legenda
      <a class="pull-right" ng-click="maps.legendaVisible = !maps.legendaVisible">
        <small>
          <i class="fa" ng-class="{'fa-eye': !maps.legendaVisible, 'fa-eye-slash': maps.legendaVisible}"></i>
          <span ng-show="maps.legendaVisible">Ocultar</span>
          <span ng-show="!maps.legendaVisible">Mostrar</span>
          legenda
        </small>
      </a>
    </h3>
    <div ng-show="maps.legendaVisible" class="ibox no-margin">
      <div class="ibox-title">
        <ui-select name="legend" id="legend" ng-model="mapas.activeLegend">
          <ui-select-match search-enabled="false" placeholder="Legenda Ativa">{{mapas.getLegendDescription(mapas.activeLegend) | limitTo:28}}</ui-select-match>
          <ui-select-choices repeat="map in mapas.getSelectedWithLegend() track by map.id">
            {{mapas.getLegendDescription(map)}}
          </ui-select-choices>
        </ui-select>
      </div>
      <div class="ibox-content padding-left-5 padding-right-5 padding-top-10 padding-bottom-5" ng-if="mapas.activeLegend">
        <ul class="unstyled">
          <li ng-repeat="item in mapas.activeLegend.mapData.legend">
            <span
              ng-style="{width: '10px', height: '10px', display: 'inline-block', backgroundColor: 'rgba('+item.color_rgba+')'}"></span> {{item.min | number:3}} - {{item.max ? (item.max | number:3) : ''}}
          </li>
        </ul>
        <div ng-if="mapas.activeLegend.mapData.tipo === 'ndvi'">
          <h3 style="margin-left: 15px;">
            <a
              ng-click="mapas.modalNdvi()"
              prevent-event
              class="pointer margin-right"
              title="Comparativo de mapas NDVI selecionados"
            >
              <i class="fa fa-line-chart"></i>
            </a>

            Variação: {{(mapas.activeLegend.mapData.legend[mapas.activeLegend.mapData.legend.length - 1].min - mapas.activeLegend.mapData.legend[0].min) | number:3}}
          </h3>
        </div>
        <div
          ng-if="mapas.activeLegend.mapData.tipo !== 'ndvi'"
          class="map-data-legend"
          ng-style="{
            background: mapas.activeLegend.mapData.gradient
          }"
          style="width: 100%; height: 20px; margin: 5px 0 36px;"></div>
        <div
          ng-if="mapas.activeLegend.mapData.tipo !== 'ndvi'"
          class="color-marker"
          ng-style="{
            left: mapas.activeLegend.mapData.legendPosition+'px'
          }"
          style="position: absolute; margin-top: -36px;">
          <i class="fa fa-arrow-up"></i>
          <br>
          <b
            ng-style="{
              left: mapas.activeLegend.mapData.legendPosition > 145
                ? '-35px'
                : ''
            }"
            style="position: relative;"
          >
            {{mapas.activeLegend.mapData.mapPointValue | number:1}}
          </b>
        </div>
        <small class="pull-left">
          {{mapas.activeLegend.mapData.minValue | number:1}}
        </small>
        <small class="pull-right">
          {{mapas.activeLegend.mapData.maxValue | number:1}}
        </small>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>

  <div class="container-body width-100">
    <p class="text-center" ng-show="!mapas.maps.length">
      <small>Nenhum mapa de dados</small>
    </p>

    <div infinite-scroll="mapas.listMaps()"
         infinite-scroll-container="'historico-mapas'"
         infinite-scroll-disabled="!mapas.initialized">
      <div
        class="panel panel-default"
        ng-class="mapas.selected.includes(map.id) ? 'panel-checked' : 'panel-unchecked'"
        ng-repeat="map in mapas.maps track by map.id">
        <div class="checkbox" prevent-default ng-click="mapas.toggleBulkPrint(map)">
          <input type="checkbox" ng-checked="mapas.bulkPrint.includes(map)" name="bulkPrint[]">
        </div>
        <div class="panel-body" ng-click="mapas.toggleShowOnMap(map)">
          <div class="box-area-title width-100" ng-hide="mapas.filters.gleba">
            <h4>
             <ng-include src="'acoes-mapa.html'"></ng-include>
              {{::map.gleba.descricao}}
              <br>
              <small>
                {{::map.descricao}}
                <br>
                <strong> <i class="fa fa-calendar"></i> </strong> {{::map.data | date}}
                <span ng-show="map.observation">
                  <br>
                  <strong>Obs: </strong>{{map.observation}}
                </span>
              </small>
            </h4>
          </div>

          <div class="box-area-title width-100" ng-show="mapas.filters.gleba">
            <h4>
             <ng-include src="'acoes-mapa.html'"></ng-include>
              {{::map.descricao}}
              <small>
                <br>
                <strong> <i class="fa fa-calendar"></i> </strong> {{::map.data | date}}
                <span ng-show="map.observation">
                  <br>
                  <strong>Obs: </strong>{{map.observation}}
                </span>
              </small>
            </h4>
          </div>
          <div class="box-area width-30" ng-show="mapas.loading">
            <i class="fa fa-2x fa-spinner fa-spin text-white"></i>&nbsp;
          </div>
          <div class="box-area width-30" ng-hide="mapas.loading" style="margin-left: auto; margin-right: auto;">
            <img ng-src="{{map.imagem.thumb}}" class="media-object width-100">&nbsp;
          </div>
          <ng-include src="'print-mapa.html'"></ng-include>
          <a
            ng-click="mapas.modalPragasVsAplicacoes(map)"
            prevent-event
            class="pointer"
            ng-if="map.mapData && mapas.selected.includes(map.id) && map.tipo == 'pragas'"
          >
            <i class="fa fa-line-chart"></i> Histórico da praga
          </a>
          <legenda-indicador 
            ng-if="map.mapData && mapas.selected.includes(map.id) && map.tipo == 'pragas'"
            dados="map.mapData.dados.tipo"> 
          </legenda-indicador>          
          <a
            ng-click="mapas.toggleRgbNdvi(map)"
            prevent-event
            style="cursor: pointer;"
            ng-if="mapas.selected.includes(map.id) && map.mapData && map.automatic && map.tipo == 'ndvi'"
          >
            Visualizar imagem RGB - cores naturais para conferir nuvens
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<script type="text/ng-template" id="acoes-mapa.html">
  <div class="pull-right">
    <button
      type="button"
      class="no-padding btn-link btn-small btn-no-outline"
      ng-click="mapas.toggleFavorite($event, map)"
      title="{{ map.favorite ? 'Desfavoritar' : 'Favoritar' }}"
    >
      <i
        class="fa pointer"
        ng-class="{'fa-star-o': !map.favorite, 'fa-star': map.favorite}">
      </i>
    </button>
    <button
      type="button"
      class="no-padding btn-link btn-small btn-no-outline"
      ng-click="mapas.editObservation($event, map)"
      title="Editar observação"
    >
      <i class="fa fa-edit pointer"></i>
    </button>
    <button
      type="button"
      class="no-padding btn-link btn-small btn-no-outline"
      ng-click="mapas.inactivateMap($event, map)"
      ng-if="mapas.canDelete(map)"
      title="Excluir Mapa"
    >
      <i class="fa fa-trash"></i>
    </button>
    <button
      type="button"
      ng-disabled="!map.mapData"
      class="no-padding btn-link btn-small btn-no-outline pointer"
      prevent-event ng-print
      print-element-id="print-{{map.id}}"
      title="{{map.mapData ? 'Imprimir mapa' : 'Selecione o mapa para habilitar a impressão'}}"
    >
      <i class="fa fa-print"></i>
    </button>
  </div>
</script>

<script type="text/ng-template" id="print-mapa.html">
  <div id="print-{{map.id}}" class="only-print">
    <br>
    <h1 class="no-margin text-cinza">
      {{::map.descricao}} | {{::map.gleba.descricao}} | {{::map.data | date}}
    </h1>

    <ul class="unstyled map-print-legenda">
      <li ng-repeat="item in map.mapData.legend">
        <p>
          <span ng-style="{borderColor: 'rgba('+item.color_rgba+')'}"></span> {{item.min | number:3}} - {{item.max ? (item.max | number:3) : ''}}
        </p>
      </li>
    </ul>
    <div ng-if="map.mapData.tipo === 'ndvi'">
      <h3>Variação: {{(map.mapData.legend[map.mapData.legend.length - 1].min - map.mapData.legend[0].min) | number:3}}</h3>
    </div>
    <img ng-src="{{map.imagem.url}}" class="map-print center-and-middle">
  </div>
</script>

<script type="text/ng-template" id="bulk-print-maps.html">
  <div class="only-print" id="bulk-print-maps">
    <div class="grid-print page-break" ng-repeat="page in mapas.chunkedBulkPrint">
      <div ng-repeat="map in page">
        <h3 class="no-margin text-cinza">
          {{::map.descricao}} | {{::map.gleba.descricao}} | {{::map.data | date}}
        </h3>
        <div class="map-image-container">
          <img ng-src="{{map.imagem.url}}">
          <div class="map-legenda">
            <ul class="unstyled map-print-legenda">
              <li ng-repeat="item in map.mapData.legend" style="white-space: nowrap;">
                <span
                  ng-style="{borderColor: 'rgba('+item.color_rgba+')'}"
                  style="display: inline-block; margin-right: 2px; width: 0; height: 5px; border-width: 5px;"></span> {{item.min | number:3}} - {{item.max ? (item.max | number:3) : ''}}
              </li>
            </ul>
            <div ng-if="map.mapData.tipo === 'ndvi'">
              <h3>Variação: {{(map.mapData.legend[map.mapData.legend.length - 1].min - map.mapData.legend[0].min) | number:3}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</script>
